<ace-editor [(text)]="code" mode="json" style="height:400px;"></ace-editor>

<ngx-json-viewer [json]="data"></ngx-json-viewer>
